export class PaginaModel {
  public larguraPapel: string;
}
